// Auto-generated by /app/scripts/generate_meal_images.py.
// Maps meal IDs to bespoke AI-generated food photographs.
// If a meal isn't in this map, the original Unsplash stock URL from dietMeals.js is used.

export const MEAL_AI_IMAGES = {
  b1: '/meal-images/b1.jpg',
  b2: '/meal-images/b2.jpg',
  b3: '/meal-images/b3.jpg',
  b4: '/meal-images/b4.jpg',
  b5: '/meal-images/b5.jpg',
  b6: '/meal-images/b6.jpg',
  l1: '/meal-images/l1.jpg',
  l2: '/meal-images/l2.jpg',
  l3: '/meal-images/l3.jpg',
  l4: '/meal-images/l4.jpg',
  l5: '/meal-images/l5.jpg',
  l6: '/meal-images/l6.jpg',
  l7: '/meal-images/l7.jpg',
  l8: '/meal-images/l8.jpg',
  d1: '/meal-images/d1.jpg',
  d2: '/meal-images/d2.jpg',
  d3: '/meal-images/d3.jpg',
  d4: '/meal-images/d4.jpg',
  d5: '/meal-images/d5.jpg',
  d6: '/meal-images/d6.jpg',
  d7: '/meal-images/d7.jpg',
  d8: '/meal-images/d8.jpg',
  s1: '/meal-images/s1.jpg',
  s2: '/meal-images/s2.jpg',
  s3: '/meal-images/s3.jpg',
  s4: '/meal-images/s4.jpg',
  sm1: '/meal-images/sm1.jpg',
  sm2: '/meal-images/sm2.jpg',
  sm3: '/meal-images/sm3.jpg',
  sm4: '/meal-images/sm4.jpg',
  l9: '/meal-images/l9.jpg',
  l10: '/meal-images/l10.jpg',
  l11: '/meal-images/l11.jpg',
  l12: '/meal-images/l12.jpg',
  l13: '/meal-images/l13.jpg',
  l14: '/meal-images/l14.jpg',
  l15: '/meal-images/l15.jpg',
  l16: '/meal-images/l16.jpg',
  d9: '/meal-images/d9.jpg',
  d10: '/meal-images/d10.jpg',
  d11: '/meal-images/d11.jpg',
  d12: '/meal-images/d12.jpg',
  d13: '/meal-images/d13.jpg',
  d14: '/meal-images/d14.jpg',
  d15: '/meal-images/d15.jpg',
  d16: '/meal-images/d16.jpg',
  d17: '/meal-images/d17.jpg',
  d18: '/meal-images/d18.jpg',
  b7: '/meal-images/b7.jpg',
  s5: '/meal-images/s5.jpg',
  ru1: '/meal-images/ru1.jpg',
  ru2: '/meal-images/ru2.jpg',
  ru3: '/meal-images/ru3.jpg',
  ru4: '/meal-images/ru4.jpg',
  ru5: '/meal-images/ru5.jpg',
  ru6: '/meal-images/ru6.jpg',
  ru7: '/meal-images/ru7.jpg',
  ru8: '/meal-images/ru8.jpg',
  ru9: '/meal-images/ru9.jpg',
  ru10: '/meal-images/ru10.jpg',
  ua1: '/meal-images/ua1.jpg',
  ua2: '/meal-images/ua2.jpg',
  ua3: '/meal-images/ua3.jpg',
  ua4: '/meal-images/ua4.jpg',
  ua5: '/meal-images/ua5.jpg',
  ua6: '/meal-images/ua6.jpg',
  ua7: '/meal-images/ua7.jpg',
  ua8: '/meal-images/ua8.jpg',
  ua9: '/meal-images/ua9.jpg',
  ua10: '/meal-images/ua10.jpg',
  pt1: '/meal-images/pt1.jpg',
  pt2: '/meal-images/pt2.jpg',
  pt3: '/meal-images/pt3.jpg',
  pt4: '/meal-images/pt4.jpg',
  pt5: '/meal-images/pt5.jpg',
  pt6: '/meal-images/pt6.jpg',
  pt7: '/meal-images/pt7.jpg',
  pt8: '/meal-images/pt8.jpg',
  pt9: '/meal-images/pt9.jpg',
  pt10: '/meal-images/pt10.jpg',
  fr1: '/meal-images/fr1.jpg',
  fr2: '/meal-images/fr2.jpg',
  fr3: '/meal-images/fr3.jpg',
  fr4: '/meal-images/fr4.jpg',
  fr5: '/meal-images/fr5.jpg',
  fr6: '/meal-images/fr6.jpg',
  fr7: '/meal-images/fr7.jpg',
  fr8: '/meal-images/fr8.jpg',
  fr9: '/meal-images/fr9.jpg',
  fr10: '/meal-images/fr10.jpg',
  it1: '/meal-images/it1.jpg',
  it2: '/meal-images/it2.jpg',
  it3: '/meal-images/it3.jpg',
  it4: '/meal-images/it4.jpg',
  it5: '/meal-images/it5.jpg',
  it6: '/meal-images/it6.jpg',
  it7: '/meal-images/it7.jpg',
  it8: '/meal-images/it8.jpg',
  it9: '/meal-images/it9.jpg',
  it10: '/meal-images/it10.jpg',
  es1: '/meal-images/es1.jpg',
  es2: '/meal-images/es2.jpg',
  es3: '/meal-images/es3.jpg',
  es4: '/meal-images/es4.jpg',
  es5: '/meal-images/es5.jpg',
  es6: '/meal-images/es6.jpg',
  es7: '/meal-images/es7.jpg',
  es8: '/meal-images/es8.jpg',
  es9: '/meal-images/es9.jpg',
  es10: '/meal-images/es10.jpg',
  kr1: '/meal-images/kr1.jpg',
  kr2: '/meal-images/kr2.jpg',
  kr3: '/meal-images/kr3.jpg',
  kr4: '/meal-images/kr4.jpg',
  kr5: '/meal-images/kr5.jpg',
  kr6: '/meal-images/kr6.jpg',
  kr7: '/meal-images/kr7.jpg',
  kr8: '/meal-images/kr8.jpg',
  kr9: '/meal-images/kr9.jpg',
  kr10: '/meal-images/kr10.jpg',
  m1: '/meal-images/m1.jpg',
  m2: '/meal-images/m2.jpg',
  m3: '/meal-images/m3.jpg',
  m4: '/meal-images/m4.jpg',
  m5: '/meal-images/m5.jpg',
  m6: '/meal-images/m6.jpg',
  m7: '/meal-images/m7.jpg',
  m8: '/meal-images/m8.jpg',
  m9: '/meal-images/m9.jpg',
  m10: '/meal-images/m10.jpg',
  m11: '/meal-images/m11.jpg',
  m12: '/meal-images/m12.jpg',
  it11: '/meal-images/it11.jpg',
  it12: '/meal-images/it12.jpg',
  it13: '/meal-images/it13.jpg',
  it14: '/meal-images/it14.jpg',
  it15: '/meal-images/it15.jpg',
  it16: '/meal-images/it16.jpg',
  fr11: '/meal-images/fr11.jpg',
  fr12: '/meal-images/fr12.jpg',
  fr13: '/meal-images/fr13.jpg',
  fr14: '/meal-images/fr14.jpg',
  fr15: '/meal-images/fr15.jpg',
  es11: '/meal-images/es11.jpg',
  es12: '/meal-images/es12.jpg',
  es13: '/meal-images/es13.jpg',
  es14: '/meal-images/es14.jpg',
  pt11: '/meal-images/pt11.jpg',
  pt12: '/meal-images/pt12.jpg',
  pt13: '/meal-images/pt13.jpg',
  ru11: '/meal-images/ru11.jpg',
  ru12: '/meal-images/ru12.jpg',
  ru13: '/meal-images/ru13.jpg',
  ua11: '/meal-images/ua11.jpg',
  ua12: '/meal-images/ua12.jpg',
  ua13: '/meal-images/ua13.jpg',
  kr11: '/meal-images/kr11.jpg',
  kr12: '/meal-images/kr12.jpg',
  kr13: '/meal-images/kr13.jpg',
  kr14: '/meal-images/kr14.jpg',
  in1: '/meal-images/in1.jpg',
  in2: '/meal-images/in2.jpg',
  in3: '/meal-images/in3.jpg',
  in4: '/meal-images/in4.jpg',
  mx1: '/meal-images/mx1.jpg',
  mx2: '/meal-images/mx2.jpg',
  mx3: '/meal-images/mx3.jpg',
  gr1: '/meal-images/gr1.jpg',
  gr2: '/meal-images/gr2.jpg',
  gr3: '/meal-images/gr3.jpg',
  ds1: '/meal-images/ds1.jpg',
  ds2: '/meal-images/ds2.jpg',
  ds3: '/meal-images/ds3.jpg',
  ds4: '/meal-images/ds4.jpg',
  ds5: '/meal-images/ds5.jpg',
  ds6: '/meal-images/ds6.jpg',
  ds7: '/meal-images/ds7.jpg',
  ds8: '/meal-images/ds8.jpg',
  ds9: '/meal-images/ds9.jpg',
  ds10: '/meal-images/ds10.jpg',
  ds11: '/meal-images/ds11.jpg',
  ds12: '/meal-images/ds12.jpg',
  ds13: '/meal-images/ds13.jpg',
  ds14: '/meal-images/ds14.jpg',
  ds15: '/meal-images/ds15.jpg',
  ds16: '/meal-images/ds16.jpg',
  ds17: '/meal-images/ds17.jpg',
  ds18: '/meal-images/ds18.jpg',
  ds19: '/meal-images/ds19.jpg',
  ds20: '/meal-images/ds20.jpg',
  ds21: '/meal-images/ds21.jpg',
  ds22: '/meal-images/ds22.jpg',
  ds23: '/meal-images/ds23.jpg',
  ds24: '/meal-images/ds24.jpg',
  ds25: '/meal-images/ds25.jpg',
  ds26: '/meal-images/ds26.jpg',
  ds27: '/meal-images/ds27.jpg',
  ds28: '/meal-images/ds28.jpg',
  ds29: '/meal-images/ds29.jpg',
  ds30: '/meal-images/ds30.jpg',
};

export function imageForMeal(meal) {
  if (!meal) return '';
  return MEAL_AI_IMAGES[meal.id] || meal.image;
}
